import * as React from 'react'

export function Chevron(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 8" {...props}>
            <path fill="currentColor" d="M.5 1.4l1-1 5 5.1 5-5 1 1-6 6-6-6z" />
        </svg>
    )
}
